import { storeModule } from './store'
import { StorefrontModule } from '@vue-storefront/core/lib/modules'

const KEY = 'wordpress'

export const Wordpress: StorefrontModule = function Wordpress ({ store }) {
  store.registerModule(KEY, storeModule)
}
